import { Injectable, inject } from '@angular/core';
import type { Timer } from '@freelancer/time-utils';
import { TimeUtils } from '@freelancer/time-utils';

@Injectable({ providedIn: 'root' })
export class RelativeTime {
  private timeUtils = inject(TimeUtils);

  scheduleTick(tick: () => void, delay: number): Timer {
    return this.timeUtils.setInterval(tick, delay);
  }
}
